<div class="cookie-banner" *ngIf="showBanner">
  <p i18n="@@cookieBannerMessage">
    We use cookies to enhance your experience and analyze site usage. 
    You can accept all cookies or continue with only essential ones.
    <a routerLink="/privacy">Learn more</a>
  </p>

  <div class="actions">
    <button mat-stroked-button color="primary" class="reject-btn" (click)="rejectCookies()" i18n="@@rejectCookiesBtn">Reject Cookies</button>
    <button mat-raised-button color="primary" (click)="acceptCookies()" i18n="@@acceptCookiesBtn">Accept Cookies</button>
  </div>
</div>
